import GlobalComponents from './globalComponents';
import GlobalDirectives from "./globalDirectives";

//css assets
import '@/assets/css/tfcc-core.min.css'
import '@/assets/adminConsole/css/custom.css'

export default {
    install(Vue) {
        Vue.use(GlobalComponents);
        Vue.use(GlobalDirectives);
    }
}